import {
  ArticleResolution,
  ArticleSortType,
  FeatureRequestResolutions,
  Label,
} from '@wix/answers-api';
import {
  ALL_RESOLUTIONS,
  RoadmapFeatureResolution,
  RoadmapFilterType,
} from './../types';

export const isRoadmapArticle = (
  articleResolution: ArticleResolution,
  labels: Label[],
  roadmapLabels: Label[]
) => {
  const roadMapLabelsIds = roadmapLabels.map((roadmapLabel) => roadmapLabel.id);
  return (
    ALL_RESOLUTIONS.includes(articleResolution) &&
    labels.map((l) => l.id).some((label) => roadMapLabelsIds.includes(label))
  );
};

export const statusToClass: Record<FeatureRequestResolutions, string> = {
  [ArticleResolution.COLLECTING_VOTES]: 'planned',
  [ArticleResolution.PLANNED]: 'planned',
  [ArticleResolution.IN_DEVELOPMENT]: 'in-dev',
  [ArticleResolution.COMING_SOON]: 'pre-launch',
  [ArticleResolution.RELEASED]: 'released',
};

export const FilterToName: Record<RoadmapFilterType, string> = {
  [RoadmapFilterType.ALL]: 'all',
  [RoadmapFilterType.ETA_NEXT_QUARTER]: 'next-quarter',
  [RoadmapFilterType.ETA_THIS_QUARTER]: 'this-quarter',
  [RoadmapFilterType.FOLLOWING]: 'following',
};
export const tabToName = (resolution: RoadmapFeatureResolution) => {
  switch (resolution) {
    case 'all':
      return 'all';
    case ArticleResolution.PLANNED:
      return 'planned';
    case ArticleResolution.IN_DEVELOPMENT:
      return 'working on it';
    case ArticleResolution.COMING_SOON:
      return 'pre launch';
    case ArticleResolution.RELEASED:
      return 'launched';
    default:
      break;
  }
};

export const sortTypeToName = (sortType: ArticleSortType) => {
  switch (sortType) {
    case ArticleSortType.LAST_UPDATE_DATE_DESC:
      return 'recently updated';
    case ArticleSortType.RESOLUTION_ETA_DESC:
      return 'closest eta';
    case ArticleSortType.VOTES_DESC:
      return 'most popular';
    default:
      break;
  }
};
const getCurrentQuoter = (eta: Date | number) =>
  Math.ceil((new Date(eta).getMonth() + 1) / 3);

const getNextQuarter = (quarter: number) => (quarter === 4 ? 1 : quarter + 1);

export type Quarter = {
  quarterNumber: number;
  year: number;
};
export const getQuarterFromDate: (date: Date) => Quarter = (date) => {
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  return { quarterNumber: Math.ceil(month / 3), year };
};
export const getDateFromQuarter = (quarter: Quarter) => {
  const { quarterNumber, year } = quarter;
  switch (quarterNumber) {
    case 1:
    case 4:
      return new Date(`${quarterNumber * 3}/31/${year} 23:00`).getTime();
    default:
      return new Date(`${quarterNumber * 3}/30/${year} 23:00`).getTime();
  }
};

export const getFormattedDate = (eta: number) => {
  const date = new Date(eta);
  return date.toISOString().slice(0, -5);
};

export const getFirstDateOfQuarter = (quarter: Quarter) => {
  const { quarterNumber, year } = quarter;
  return new Date(`${quarterNumber * 3 - 2}/01/${year} 12:00`).getTime();
};

export const getResolutionEtaFilters = (filterType: RoadmapFilterType) => {
  const date = new Date();
  if (filterType === RoadmapFilterType.ETA_THIS_QUARTER) {
    const quarter = getCurrentQuoter(date);
    const year = date.getFullYear();
    const currentQuarter = {
      quarterNumber: quarter,
      year,
    };
    const firstDateOfQuarter = getFirstDateOfQuarter(currentQuarter);
    const selectedToQuarterEnd = getDateFromQuarter(currentQuarter);
    return {
      fromResolutionEta: getFormattedDate(firstDateOfQuarter),
      toResolutionEta: getFormattedDate(selectedToQuarterEnd),
      hasResolutionEta: true,
    };
  }
  if (filterType === RoadmapFilterType.ETA_NEXT_QUARTER) {
    const quarter = getNextQuarter(getCurrentQuoter(date));
    const year = quarter === 1 ? date.getFullYear() + 1 : date.getFullYear();
    const nextQuarter = {
      quarterNumber: quarter,
      year,
    };
    const firstDateOfQuarter = getFirstDateOfQuarter(nextQuarter);
    const selectedToQuarterEnd = getDateFromQuarter(nextQuarter);
    return {
      fromResolutionEta: getFormattedDate(firstDateOfQuarter),
      toResolutionEta: getFormattedDate(selectedToQuarterEnd),
      hasResolutionEta: true,
    };
  }
  return {
    fromResolutionEta: null,
    toResolutionEta: null,
    hasResolutionEta: null,
  };
};

export type EventRoadmapData = {
  clickedUrl?: string;
  clickedText?: string;
  clickedItemOrder?: string;
  clickedItemId?: string;
};

export const getRoadmapLabels = (allLabels: Label[]) => {
  const roadmapLabels = allLabels
    .filter((l) => l.name.startsWith('Roadmap:'))
    .map((roadmapLabel) => ({
      ...roadmapLabel,
      name: roadmapLabel.name.replace('Roadmap:', ''),
    }));
  return roadmapLabels;
};
